import { createFrontendModule } from '@backstage/frontend-plugin-api';
import tabs from './tabs';

export const catalogModule = createFrontendModule({
  pluginId: 'app',
  extensions: [...tabs],
});
